import mycoverai from '@mycoverai/mca-javascript-sdk'
import type { VoidInspectionContext } from '~/components/Dialogs/void-inspection-screen.vue'

// Types
type UDataProps = {
	policy_id: string
	provider_id?: string
	inspection_type?: string
	link_type?: string
	link_id?: string
	claim_id?: string
	is_global?: boolean
}

interface ConfigProps {
	u_data: UDataProps
	progress?: string
	publicKey: string
	productId: string[] | undefined
	paymentOption: string
	reference: string // optional. supply reference when you want the user to continue to the insurance activation step. This only applies to users who have previously bought insurance using this SDK
	form?: { [key: string]: unknown }
	onClose?: Function | Promise<unknown>
	callback?: Function | Promise<unknown>
	action: string
	promo_code?: string
	claim_type?: string
	policy_number?: string
	landingUrls?: string[]
	isStaging?: boolean
}

export const constructInspectionLink = (category: string, inspectionLink: string) => {
	const { baseUrl } = useUtils()
	const inspectionDataResult = shallowRef<VoidInspectionContext>({
		title: String(category).toLowerCase()?.includes('gadget') ? 'Gadget Inspection' : 'Vehicle Inspection',
		key: 'inspection',
		QrCodeLink: ''
	})

	if (!inspectionLink) {
		useNotification().alert({
			status: 400,
			message: 'Inspection link not available, contact support.'
		})
		return null
	}
	const link = new URL(inspectionLink)
	const constructed_url = `${baseUrl.value}${link?.search?.replace('?q=', '?inspectionSdk=')}`
	inspectionDataResult.value = {
		...inspectionDataResult.value,
		QrCodeLink: constructed_url
	}

	return inspectionDataResult.value
}

export const useMcaSdk = () => {
	const initializeSdk = (cg: Record<string, unknown> & { callback?: Function; onClose?: Function }) => {
		const getString = (v: unknown) => (typeof v === 'string' ? v : v === undefined || v === null ? '' : String(v))

		const payload: ConfigProps = {
			publicKey: getString(cg['pk']),
			reference: getString(cg['reference']),
			progress: typeof cg['progress'] === 'string' ? (cg['progress'] as string) : undefined,
			action: getString(cg['action']) || 'purchase',
			paymentOption: getString(cg['payment_option']) || 'gateway',
			u_data: {
				policy_id: getString(cg['policy_id']),
				claim_id: typeof cg['claim_id'] === 'string' ? (cg['claim_id'] as string) : undefined,
				inspection_type:
					typeof cg['inspection_type'] === 'string' ? (cg['inspection_type'] as string) : undefined,
				is_global: typeof cg['is_global'] === 'boolean' ? (cg['is_global'] as boolean) : undefined,
				link_id: typeof cg['link_id'] === 'string' ? (cg['link_id'] as string) : undefined,
				link_type: typeof cg['link_type'] === 'string' ? (cg['link_type'] as string) : undefined,
				provider_id: typeof cg['provider_id'] === 'string' ? (cg['provider_id'] as string) : undefined
			},
			claim_type: typeof cg['claim_type'] === 'string' ? (cg['claim_type'] as string) : undefined,
			promo_code: typeof cg['mca_promo_code'] === 'string' ? (cg['mca_promo_code'] as string) : undefined,
			productId: cg['pid'] ? [getString(cg['pid'])] : undefined,
			isStaging: import.meta.env.VITE_Development === 'development'
		}

		return mycoverai(payload as unknown as Parameters<typeof mycoverai>[0])
	}

	return { initializeSdk }
}
